import { SocialPlatform, type AppConfig } from "@iyk/vf-app-config"

export const appConfig: AppConfig<"ari-lennox"> = {
  appId: "ari-lennox",
  cookiePrefix: "al",
  lang: "EN",
  admins: {
    mfaEnabled: true,
    otpExpiration: "10 minutes",
    sessionDuration: "30 days"
  },
  artist: {
    name: "Ari Lennox"
  },
  meta: {
    description: "Ari Lennox"
  },
  emailSender: {
    name: "Ari Lennox",
    email: "arilennox@iyk.app"
  },
  s3: {
    get assets() {
      const baseUrl = "https://assets.iyk.app"
      return {
        baseUrl,
        vfUrl: `${baseUrl}/vf`,
        appUrl: `${baseUrl}/${appConfig.appId}`
      }
    },
    get files() {
      return {
        exclusives: `${appConfig.appId}/exclusives`,
        fanClips: `${appConfig.appId}/fan-clips`,
        merchSkus: `${appConfig.appId}/merch-skus`,
        playlistCoverImages: `${appConfig.appId}/playlist-cover-images`,
        showImages: `${appConfig.appId}/show-images`,
        showCheckInRequestImages: `${appConfig.appId}/check-in-request-images`
      }
    },
    get music() {
      return {
        trackAudios: `${appConfig.appId}/track-audios`,
        playlistDownloadFiles: `${appConfig.appId}/playlist-download-files`
      }
    }
  },
  merch: {
    initialOwnerId: "00000000-0000-0000-0000-000000000000",
    initialOwnerAddress: "0x82Afa631AE80113b59b60Cf42c1d3B6d31ED19Fc"
  },
  tasks: {
    exclusiveLinkDelay: "1 hour"
  },
  checkIn: {
    hidePrompt: true
  },
  shopUrl: "https://store.arilennox.com?utm_source=iyk&utm_medium=referral",
  socialLinks: [
    {
      platform: SocialPlatform.Facebook,
      href: "https://www.facebook.com/AriLennox",
      label: "Facebook"
    },
    {
      platform: SocialPlatform.Instagram,
      href: "https://www.instagram.com/arilennox",
      label: "Instagram"
    },
    {
      platform: SocialPlatform.TikTok,
      href: "https://www.tiktok.com/@arilennox",
      label: "TikTok"
    },
    {
      platform: SocialPlatform.Spotify,
      href: "https://open.spotify.com/artist/1vaQ6v3pOFxAIrFoPrAcom",
      label: "Spotify"
    }
  ],
  joinProof: null,
  get assets() {
    return {
      images: {
        avatar: `${appConfig.s3.assets.appUrl}/avatar.webp`,
        og: `${appConfig.s3.assets.appUrl}/og.png`,
        logo: {
          url: `${appConfig.s3.assets.appUrl}/logo.png`,
          width: 100
        },
        email: {
          logo: {
            url: `${appConfig.s3.assets.appUrl}/logo-dark.png`,
            width: 100
          }
        },
        background: `${appConfig.s3.assets.appUrl}/background.webp`,
        howToTap: null,
        roulette: {
          images: Array.from({ length: 6 }, (_, i) => `${appConfig.s3.assets.vfUrl}/roulette/${i + 1}.webp`)
        },
        enableLocation: {
          ios: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_1.png`,
            step2: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_2.png`
          },
          android: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_android.png`
          }
        }
      },
      videos: {
        marquee: null,
        howToTap: null
      },
      documents: {
        privacyPolicy: `${appConfig.s3.assets.baseUrl}/iyk-privacy-policy.pdf`,
        termsOfService: `${appConfig.s3.assets.baseUrl}/iyk-terms-of-service.pdf`,
        artistPrivacyPolicy: "https://privacy.umusic.com/",
        artistTermsOfService: "https://www.universalmusic.com/ccpa/",
        sweepstakeRules: null
      }
    }
  }
}
